// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ns-z","videoWrapper":"os-z","twoColumnImage":"ps-z","imageCarouselBtn":"qs-z","carouselNextBtn":"rs-z","carouselPrevBtn":"ss-z"};